import { get } from 'lodash';
import { SENTRY_VIEWER_SCRIPT_DSN } from '../constants/sentry-viewer-script-dsn';

const isProduction = process.env.NODE_ENV === 'production';

export const getEnvironmentTag = ({ origin, isSSR }) =>
  `${origin}-${isSSR ? 'ssr' : 'csr'}${!isProduction ? '-dev' : ''}`;

export function createMonitoring({ platformAPIs, appParams, isSSR, isDebug, type, origin }) {
  const { fedOpsLoggerFactory, monitoring } = platformAPIs;

  const sentry = monitoring.createMonitor(SENTRY_VIEWER_SCRIPT_DSN, data => {
    data.environment = getEnvironmentTag({ origin, isSSR });
    return data;
  });

  const fedopsLogger = fedOpsLoggerFactory.getLoggerForWidget({
    appId: appParams.appDefinitionId,
    widgetId: type,
  });

  const captureToSentry = e => {
    sentry.captureException(e);
    const errorId = sentry.lastEventId();
    if (isDebug || !isProduction) {
      console.log('error captured to Sentry:', errorId);
    }
    return errorId;
  };

  return {
    sentry,
    captureToSentry,
    fedopsLogger,
  };
}

export const normalizeError = error => {
  if (get(error, 'constructor.name') === 'Response' && error.stack) {
    return error.stack;
  }
  return error;
};
